import { useEffect, useState } from 'react';
import { setToLS, getFromLS } from '../utils/storage';
import _ from 'lodash';
import themes from './themes.json';

export const useTheme = () => {
  // const themes = getFromLS('all-themes');
  const [theme, setTheme] = useState(themes.data.calm);
  const [themeLoaded, setThemeLoaded] = useState(false);

  const setMode = mode => {
    setToLS('theme', mode)
    setTheme(mode);
  };

  const getFonts = () => {
    const allFonts = _.values(_.mapValues(themes.data, 'font'));
    return allFonts;
  }

  useEffect(() =>{
    const localTheme = getFromLS('theme');
    if(localTheme){
      setTheme(localTheme)
    }else{
      setToLS('theme', themes.data.calm)
      setTheme(themes.data.calm)
    }
    // localTheme ? setTheme(localTheme) : setTheme(themes.data.calm);
    setThemeLoaded(true);
  }, []);

  return { theme, themeLoaded, setMode, getFonts };
};

export function applyCssVars(t) {
    if (!t?.colors) return;
    const root = document.documentElement.style;
    root.setProperty("--theme1_primary", t.colors.primary);
    root.setProperty("--theme1_secondary", t.colors.secondary);
    root.setProperty("--theme1_tertiary", t.colors.tertiary);
    root.setProperty("--theme1_quarternary", t.colors.quarternary);
    root.setProperty("--card_body_color", t.colors.body);
    root.setProperty("--text_color", t.colors.text);

    // Optional: buttons / links if you use them
    if (t.colors.button) {
        root.setProperty("--btn_bg", t.colors.button.background);
        root.setProperty("--btn_text", t.colors.button.text);
    }
    if (t.colors.link) {
        root.setProperty("--link_text", t.colors.link.text);
        root.setProperty("--link_opacity", String(t.colors.link.opacity ?? 1));
    }
}